import ACTION_CONSTANTS from '../../constants/actionConstants';
import { request, success, failure } from './index';

export function getRecordBindersRequest(payload) {
  return request(ACTION_CONSTANTS.GET_RECORD_BINDERS_REQUESTED, payload);
}

export function getRecordBindersSuccess(payload) {
  return success(ACTION_CONSTANTS.GET_RECORD_BINDERS_SUCCESS, payload);
}

export function getRecordBindersFailure(payload) {
  return failure(ACTION_CONSTANTS.GET_RECORD_BINDERS_FAILURE, payload);
}

export function searchRecordBinders(payload) {
  return request(ACTION_CONSTANTS.SEARCH_RECORD_BINDERS, payload);
}

export function filterRecordBinders(payload) {
  return request(ACTION_CONSTANTS.FILTER_RECORD_BINDERS, payload);
}

export function filterRecordHistory(payload) {
  return request(ACTION_CONSTANTS.FILTER_RECORD_HISTORY, payload);
}

export function sortRecordBinders(payload) {
  return request(ACTION_CONSTANTS.SORT_RECORD_BINDERS, payload);
}

export function setCurrentRecordBinder(payload) {
  return success(ACTION_CONSTANTS.SET_CURRENT_RECORD_BINDER, payload);
}

export function getRecordHistoryRequest(payload) {
  return request(ACTION_CONSTANTS.GET_RECORD_HISTORY_REQUESTED, payload);
}

export function getRecordHistorySuccess(payload) {
  return success(ACTION_CONSTANTS.GET_RECORD_HISTORY_SUCCESS, payload);
}

export function getRecordHistoryFailure(payload) {
  return failure(ACTION_CONSTANTS.GET_RECORD_HISTORY_FAILURE, payload);
}

export function getRecordHistoryDetailsRequest(payload) {
  return request(
    ACTION_CONSTANTS.GET_RECORD_HISTORY_DETAILS_REQUESTED,
    payload,
  );
}

export function getRecordHistoryDetailsSuccess(payload) {
  return success(ACTION_CONSTANTS.GET_RECORD_HISTORY_DETAILS_SUCCESS, payload);
}

export function getRecordHistoryDetailsFailure(payload) {
  return failure(ACTION_CONSTANTS.GET_RECORD_HISTORY_DETAILS_FAILURE, payload);
}

export function resetRecordBinderProps(payload) {
  return failure(ACTION_CONSTANTS.RESET_RECORD_BINDER_PROPS, payload);
}

export function resetRecordBinderErrorProps(payload) {
  return failure(ACTION_CONSTANTS.RESET_RECORD_BINDER_ERROR_PROPS, payload);
}

export function getBinRecordBindersRequest(payload) {
  return request(ACTION_CONSTANTS.GET_BIN_RECORD_BINDERS_REQUESTED, payload);
}

export function getBinRecordBindersSuccess(payload) {
  return success(ACTION_CONSTANTS.GET_BIN_RECORD_BINDERS_SUCCESS, payload);
}

export function getBinRecordBindersFailure(payload) {
  return failure(ACTION_CONSTANTS.GET_BIN_RECORD_BINDERS_FAILURE, payload);
}

export function searchBinRecordBinders(payload) {
  return request(ACTION_CONSTANTS.SEARCH_BIN_RECORD_BINDERS, payload);
}

export function resetRecordBinderBinProps(payload) {
  return request(ACTION_CONSTANTS.RESET_RECORD_BINDER_BIN_PROPS, payload);
}

export function addRecordRequest(payload) {
  return request(ACTION_CONSTANTS.ADD_RECORD_REQUESTED, payload);
}

export function addRecordSuccess(payload) {
  return success(ACTION_CONSTANTS.ADD_RECORD_SUCCESS, payload);
}

export function addRecordFailure(payload) {
  return failure(ACTION_CONSTANTS.ADD_RECORD_FAILURE, payload);
}

export function updateRecordRequest(payload) {
  return request(ACTION_CONSTANTS.UPDATE_RECORD_REQUESTED, payload);
}

export function updateRecordSuccess(payload) {
  return success(ACTION_CONSTANTS.UPDATE_RECORD_SUCCESS, payload);
}

export function updateRecordFailure(payload) {
  return failure(ACTION_CONSTANTS.UPDATE_RECORD_FAILURE, payload);
}

export function deleteRecordRequest(payload) {
  return request(ACTION_CONSTANTS.DELETE_RECORD_REQUESTED, payload);
}

export function deleteRecordSuccess(payload) {
  return success(ACTION_CONSTANTS.DELETE_RECORD_SUCCESS, payload);
}

export function deleteRecordFailure(payload) {
  return failure(ACTION_CONSTANTS.DELETE_RECORD_FAILURE, payload);
}

// payload: { tempId, fileName, data, extension, feedlotRecordId }
export function uploadRecordAttachmentRequested(payload) {
  return request(ACTION_CONSTANTS.UPLOAD_RECORD_ATTACHMENT_REQUESTED, payload);
}

export function uploadRecordAttachmentSuccess(payload) {
  return success(ACTION_CONSTANTS.UPLOAD_RECORD_ATTACHMENT_SUCCESS, payload);
}

export function uploadRecordAttachmentFailure(payload) {
  return failure(ACTION_CONSTANTS.UPLOAD_RECORD_ATTACHMENT_FAILURE, payload);
}

export function clearRecordAttachmentUpload(payload) {
  return request(ACTION_CONSTANTS.CLEAR_RECORD_ATTACHMENT_UPLOAD, payload);
}

// Sweeps any leftover attachmentUploads entries from a previous Add/Edit
// session the user abandoned (back/cancel) before its upload(s) resolved -
// dispatched once on AddRecord mount.
export function clearAllRecordAttachmentUploads() {
  return request(ACTION_CONSTANTS.CLEAR_ALL_RECORD_ATTACHMENT_UPLOADS);
}
